import PropTypes from 'prop-types';
import PostBlockGrid from '../PostBlock/PostBlockGrid';

const SearchBlock = ({
	end = false,
	loading = false,
	nextPageHref = '',
	onLoadMore = () => { },
	posts = [],
	term = '',
	isValidating = false,
	postFilter = {},
	filters = [],
	mostRecentPosts = [],
}) => {
	const loadMoreHandler = (event) => {
		event.preventDefault();
		if (loading || end) {
			return;
		}
		onLoadMore();
	};

	const noResultsMessage = (
		<p className="no-results" role="status">
			Uh oh! We didn’t find any matches. Try removing filters to get more results.
		</p>
	);

	const loadMoreButton = (
		<a
			className="search-block-loadmore-button"
			href={nextPageHref}
			onClick={loadMoreHandler}
		>
			Load more
		</a>
	);

	const loadingButton = (
		<button className="search-block-loadmore-button" type="button">
			Loading...
		</button>
	);

	const isEmpty = () => posts?.length === 0;

	const showFeedback = term && isEmpty() && !isValidating;

	const hasFilters = filters.length > 0 || postFilter.name;

	const adConfig = {
		loadGoogleAds: true,
		loadMagniteAds: false,
	};

	return (
		<div className="search-block">
			{!isEmpty() && (
				<>
					<PostBlockGrid adConfig={adConfig} posts={posts} isLoader={false} showPostType />
					{loading && <PostBlockGrid className="loader-grid" posts={[]} isLoader />}
					<div className="search-block-footer">
						{(!end) && (loading ? loadingButton : loadMoreButton)}
					</div>
				</>
			)}
			{showFeedback && !hasFilters ? (
				<div className="search-block search-most-recent">
					<h2 className="search-most-recent-title">Most Recent</h2>
					<PostBlockGrid posts={mostRecentPosts} isLoader={false} showPostType />
				</div>
			) : null}
			{showFeedback && hasFilters ? noResultsMessage : null}
		</div>
	);
};

SearchBlock.propTypes = {
	end: PropTypes.bool,
	loading: PropTypes.bool,
	nextPageHref: PropTypes.string,
	onLoadMore: PropTypes.func,
	posts: PropTypes.arrayOf(PropTypes.object),
	term: PropTypes.string,
	isValidating: PropTypes.bool,
	postFilter: PropTypes.object,
	filters: PropTypes.array,
	mostRecentPosts: PropTypes.arrayOf(PropTypes.object),
};

export default SearchBlock;
